import { useState } from 'react'
import { Buffer } from 'buffer'
import { pageTitles } from 'navigation'

export const pageSizeConfigs = [10, 25, 50, 100, 250]
export const minPageSizeConfigs = pageSizeConfigs[0]

export const payDate = (date) => {
  if (!date) {
    return 'No Payment'
  }

  return new Date(date).toString()
}

export function currencyFormat (value) {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0
  }).format(value ?? 0)
}

export const payType = (type) => {
  if (!type) {
    return 'No Payment'
  }

  return type
}

export const nullCompensation = (data) => {
  if (!data) {
    return 'No Data'
  }

  return data
}

export const templateType = (priority, warning, overdue, paymentNotification, activeNotification) => {
  if (priority === true) {
    return (<div className="rounded-pill bg-success text-light center">Priority</div>)
  } else if (warning === true) {
    return (<div className="rounded-pill bg-warning text-light center">Warning</div>)
  } else if (overdue === true) {
    return (<div className="rounded-pill bg-danger text-light center">Overdue</div>)
  } else if (paymentNotification === true) {
    return (<div className="rounded-pill bg-info text-light center">Payment Notification</div>)
  } else if (activeNotification === true) {
    return (<div className="rounded-pill bg-primary text-light center">Active Notification</div>)
  }

  return (<div className="rounded-pill center bg-secondary text-light">Static</div>)
}

export const Datestr = (date) => {
  if (!date) {
    return 'Date not Set'
  }

  return new Date(date).toLocaleDateString('in-ID')
}

export const DateTimestr = (date) => {
  if (!date) {
    return 'Date not Set'
  }

  return new Date(date).toLocaleString('in-ID')
}

export const invoiceStatus = (date, bool = false) => {
  if (!date) {
    if (!bool) {
      return 'Batal Pembayaran'
    }

    return false
  }

  if (!bool) {
    return 'Closing Pembayaran'
  }

  return true
}

export const userStatus = (status) => {
  if (!status) {
    return 'disable'
  }

  return 'active'
}

export const WorkOrderStatus = ['waiting', 'done', 'cancel', 'overdue']

export const workOrderStatusViewer = (status) => {
  if (status === WorkOrderStatus[0]) {
    return (<div className="rounded-pill bg-warning center text-white">{status}</div>)
  }
  if (status === WorkOrderStatus[1]) {
    return (<div className="rounded-pill bg-success center text-white">{status}</div>)
  }
  if (status === WorkOrderStatus[2]) {
    return (<div className="rounded-pill bg-danger center text-white">{status}</div>)
  }
  if (status === WorkOrderStatus[3]) {
    return (<div className="rounded-pill bg-primary center text-white">{status}</div>)
  }
  return (<div className="rounded-pill bg-secondary center text-white">{status}</div>)
}

export const customTextFromBoolean = (status, trueText, falseText) => {
  if (!status) {
    return (<div className="rounded-pill bg-warning center text-white">{falseText || 'Offline'}</div>)
  }

  return (<div className="rounded-pill bg-success center text-white">{trueText || 'Online'}</div>)
}

export const customTextAndBgColorFromBoolean = (status, trueText, falseText, trueColor = 'bg-success', falseColor = 'bg-warning') => {
  if (!status) {
    return (<div className={`rounded-pill ${falseColor} center text-white`}>{falseText || 'Offline'}</div>)
  }

  return (<div className={`rounded-pill ${trueColor} center text-white`}>{trueText || 'Online'}</div>)
}

export const customTextAndBgIconColorFromBoolean = (status, trueText, falseText, trueColor = 'bg-success', falseColor = 'bg-warning') => {
  if (!status) {
    return (<div className={`rounded-pill ${falseColor} center text-white`}>{falseText || 'Offline'}</div>)
  }

  return (<div className={`rounded-pill ${trueColor} center text-white`}>{trueText || 'Online'} <i className="fa fa-list" /></div>)
}

export const customTextAndBgBothIconColorFromBoolean = (status, trueText, falseText, trueColor = 'bg-success', falseColor = 'bg-warning') => {
  if (!status) {
    return (<div className={`rounded-pill ${falseColor} center text-white`}>{falseText || 'Offline'} <i className="fa fa-list" /></div>)
  }

  return (<div className={`rounded-pill ${trueColor} center text-white`}>{trueText || 'Online'} <i className="fa fa-list" /></div>)
}

export const customTextFromBooleanDanger = (status, trueText, falseText) => {
  if (!status) {
    return (<div className="rounded-pill bg-danger center text-white">{falseText || 'Offline'}</div>)
  }

  return (<div className="rounded-pill bg-success center text-white">{trueText || 'Online'}</div>)
}

export const customTextFromBooleanReverse = (status, trueText, falseText) => {
  if (!status) {
    return (<div className="rounded-pill bg-success center text-white">{trueText || 'Online'}</div>)
  }

  return (<div className="rounded-pill bg-warning center text-white">{falseText || 'Offline'}</div>)
}

export const customTextFromBooleanReverseDanger = (status, trueText, falseText) => {
  if (!status) {
    return (<div className="rounded-pill bg-success center text-white">{trueText || 'Online'}</div>)
  }

  return (<div className="rounded-pill bg-danger center text-white">{falseText || 'Offline'}</div>)
}

export const clickableStatusView = (handleShow, data) => {
  const {
    dueColorList,
    duePositiveColorList
  } = ModalColorSelector(data)
  return (
      <div
        className="text-center font-weight-bold"
        onClick={() => handleShow(data)}
      >
        {customTextAndBgBothIconColorFromBoolean(
          (data.paidDate && data.enabled && !data.lastSubsUnpaid),
          data.networkId || 'Subs Kosong',
          data.networkId || 'Subs Kosong',
          duePositiveColorList,
          dueColorList
        )}
    </div>
  )
}

export const clickableActionStatusView = (handleShow, isTrue, labelTrue = 'No-Data', labeLFalse = 'No-Data') => {
  return (
      <div
        className="text-center font-weight-bold"
        onClick={() => {
          if (isTrue === true) {
            handleShow()
          }
        }}
      >
        {customTextAndBgIconColorFromBoolean(
          isTrue,
          labelTrue,
          labeLFalse
        )}
    </div>
  )
}

export const StatusDisplay = (status) => {
  if (!status) {
    return 'Failed'
  }

  return 'Success'
}

export const customerOperation = (status, trueText, falseText) => {
  if (!status) {
    return falseText || 'Non-Active'
  }

  return trueText || 'Active'
}

export const Downloads = (rawData, name, type, extention, middleName = 'exports') => {
  const today = new Date().toLocaleString()
  const blob = new Blob([rawData], { type: type })
  // 2. Create blob link to download
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', `${name}-${middleName}-${today}${extention}`)
  // 3. Append to html page
  document.body.appendChild(link)
  // 4. Force download
  link.click()
  // 5. Clean up and remove the link
  link.parentNode.removeChild(link)
}

export const useFormInput = (initialValue) => {
  const [value, setValue] = useState(initialValue)

  const handleChange = e => {
    setValue(e.target.value)
  }
  return {
    value,
    onChange: handleChange
  }
}

export const GlobalValueMap = (data) => {
  const keys = Object.typedKeys(data)
  const list = []
  for (let idx = 0; idx < keys.length; idx++) {
    const element = keys[idx]
    if (!data[element]) {
      continue
    } else {
      list.push({ value: data[element], label: element })
      GlobalValueMap(data[element])
    }
  }

  return list
}

export const BinnaryUpload = (fileData) => {
  const files = Array.from(fileData)

  const formData = new FormData()

  files.forEach((file) => {
    formData.append('data', file, file.name)
  })

  return formData
}

export const makePageValue = (total) => {
  const list = []
  if (total === 1 || !total) {
    list.push({ value: 1, label: 'Home' })
  } else {
    for (let idx = 1; idx <= total; idx++) {
      if (idx === 1) {
        list.push({ value: idx, label: 'Home' })
      } else {
        list.push({ value: idx, label: idx })
      }
    }
  }

  return list
}

export const MainChartData = (data) => {
  const chart = []
  for (let i = 1; i <= 12; i++) {
    if (!data) {
      chart.push(null)
      continue
    }
    const e = data.find(dat => Number(dat.month) === i)
    if (!e) {
      chart.push(null)
      continue
    }

    chart.push(Number(e.revenue))
  }

  return chart
}

export const MainChartDataProcessing = (data) => {
  if (!data) {
    return {
      chartRevenue: null,
      chartIncome: null,
      chartReceivable: null,
      chartExpense: null
    }
  }

  const { historyIncome, historyExpense, historyRevenue, historyReceivable } = data
  const chartIncome = MainChartData(historyIncome)
  const chartExpense = MainChartData(historyExpense)
  const chartRevenue = MainChartData(historyRevenue)
  const chartReceivable = MainChartData(historyReceivable)

  return {
    chartIncome,
    chartExpense,
    chartRevenue,
    chartReceivable
  }
}

export const CustomerChartDataProcessing = (data) => {
  if (!data) {
    return {
      activeCustomer: null,
      suspendCustomer: null,
      disableCustomer: null,
      stats: null
    }
  }

  const activeCustomer = []
  const suspendCustomer = []
  const disableCustomer = []
  const stats = []

  for (let i = 1; i <= 12; i++) {
    if (!data) {
      activeCustomer.push(null)
      suspendCustomer.push(null)
      disableCustomer.push(null)
      stats.push(null)
      continue
    }
    const hist = data.find(dat => Number(dat.month) === i)
    if (!hist) {
      activeCustomer.push(null)
      suspendCustomer.push(null)
      disableCustomer.push(null)
      stats.push(null)
      continue
    }

    activeCustomer.push(hist.customeractiveqty)
    suspendCustomer.push(hist.customersuspendqty)
    disableCustomer.push(hist.customerdisabledqty)
    stats.push(hist.customeractivationqty)
  }

  return {
    activeCustomer,
    suspendCustomer,
    disableCustomer,
    stats
  }
}

/**
 * Helper method for creating a range of numbers
 * range(1, 5) => [1, 2, 3, 4, 5]
 */
export const range = (from, to, step = 1) => {
  let i = from
  const range = []

  while (i <= to) {
    range.push(i)
    i += step
  }

  return range
}

export const verifyLength = (value, length) => {
  return value.length >= length
}

export const compare = (string1, string2) => {
  return string1 === string2
}

export function parseDatetime (datetime) {
  if (!datetime) {
    return {
      year: 0,
      month: 0,
      day: 0,
      hours: 0,
      minute: 0,
      second: 0,
      milisecond: 0
    }
  }

  const date = new Date(datetime)
  const year = date.getFullYear()
  const month = date.getMonth()
  const day = date.getDate()
  const hours = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()
  const milisecond = date.getMilliseconds()

  return {
    year,
    month,
    day,
    hours,
    minute,
    second,
    milisecond
  }
}

export function mapInvoicetoPeriod (invoiceData) {
  return invoiceData.map((inv) => {
    const { year } = parseDatetime(inv.date)
    const invDate = new Date(inv.date)
    const month = invDate.toLocaleString('default', { month: 'long' })

    return { month, year }
  })
}

export function generateTime (dayGen, hoursGen, minuteGen) {
  return `${dayGen}-${hoursGen}-${minuteGen}`
}

export function selectMailTemplate (dataMail, data) {
  const today = new Date().toISOString()
  const { day, hours, minute } = parseDatetime(today)
  const Today = generateTime(day, hours, minute)
  const inv = data[0]
  if (!inv.paid) {
    const due = inv.due
    const { day, hours, minute } = parseDatetime(due)
    const duedate = generateTime(day, hours, minute)
    const beforeDueDate = generateTime((day - 3), hours, minute)
    if (Today === duedate) {
      return dataMail.find(e => e.label.toLowerCase() === 'overdue')
    } else if (Today === beforeDueDate) {
      return dataMail.find(e => e.label.toLowerCase() === 'warning')
    }
  } if (inv.paid) {
    return dataMail.find(e => e.label.toLowerCase() === 'payment')
  }

  return dataMail.find(e => e.label.toLowerCase() === 'email')
}

export function selectPsbMailTemplate (dataMail, data) {
  const today = new Date().toISOString()
  const { day, hours, minute } = parseDatetime(today)
  const Today = generateTime(day, hours, minute)
  const inv = data
  if (!inv.paid) {
    const due = inv.due_date
    const { day, hours, minute } = parseDatetime(due)
    const duedate = generateTime(day, hours, minute)
    const beforeDueDate = generateTime((day - 3), hours, minute)
    if (Today === duedate) {
      return dataMail.find(e => e.label.toLowerCase() === 'overdue')
    } else if (Today === beforeDueDate) {
      return dataMail.find(e => e.label.toLowerCase() === 'warning')
    }
  } if (inv.paid) {
    return dataMail.find(e => e.label.toLowerCase() === 'payment')
  }

  return dataMail.find(e => e.label.toLowerCase() === 'email')
}

export function calculateTotal (data) {
  // Hanya untuk object dengan Price, qty
  let total = 0
  for (const val of data) {
    total = total + Number(val.price || 0) * Number(val.qty || 0)
  }

  return total
}

export function MapObjToSelectObj (listData) {
  return listData.map((list) => {
    const id = list?.id
    const sn = list?.sn
    const name = list?.name

    return {
      value: id,
      label: sn ?? `${id}-${name}`
    }
  })
}

export const convertDateLocaleString = (date) => {
  const today = new Date()
  const tz = today.getTimezoneOffset
  const date12 = new Date(date).toLocaleString('en-US', { hour12: false })
  const [first, second] = date12.split(',').map(item => item.trim())
  const [month, day, year] = first.split('/')
  const [hours, minutes, seconds] = second.split(':')

  const constructDate = `${year}-${month}-${day}:${hours}:${minutes}:${seconds}.${tz}`
  const dates = new Date(constructDate)

  return dates.toISOString()
}

export const CleanStringSpace = (str) => {
  return str.replace(/\s+/g, '')
}

export const ApprovalOperation = (type, status) => {
  if (type === 0) {
    return !status ? 'Declined' : 'Approved'
  }

  if (type === 1) {
    return !status ? 'Approved' : 'Declined'
  }
}

export const DownloadBinary = (response, filename) => {
  const blob = new Blob([response.data])
  // console.log(response.data)
  const fileURL = window.URL.createObjectURL(blob)
  // Setting various property values
  const alink = document.createElement('a')
  alink.href = fileURL
  alink.download = filename
  alink.click()
}

export const SplitString = (type, separator = '/') => {
  return type.split(separator)
}

export const ExtractHeaderData = (response) => {
  const typeData = response.headers['content-type']
  // "text/csv; charset=utf-8"
  const contentDispossion = response.headers['content-disposition']
  const [type, encoding] = SplitString(typeData || ';', ';')
  const [prefix, extention] = SplitString(type)
  const disposition = SplitString(contentDispossion || ';', ';')
  const fileNameRaw = disposition[1] || type + '-' + prefix + '-' + new Date().toLocaleDateString()
  const file = SplitString(fileNameRaw, '=')

  return {
    type,
    prefix,
    encoding,
    extention,
    filename: file[0]
  }
}

export const MapToParamQuery = (data) => {
  if (!data) {
    return '?'
  }
  const keys = Object.keys(data)
  let list = ''
  keys.forEach((key, i) => {
    if (i === 0) {
      return list + '?' + key + '=' + data[key]
    }
    list = list + '&' + key + '=' + data[key]
  })

  return list
}

export function BlobDataLen ({ blob }) {
  if (!blob) {
    return (<div className="rounded-pill bg-success center text-white">Waiting Data</div>)
  }

  return (<div className="rounded-pill bg-warning center text-white">{blob.length} Data Pending</div>)
}

export function ClassnameByNumberValue (value) {
  if (value > 0) {
    return 'text-success'
  }
  if (value < 0) {
    return 'text-danger'
  }

  return 'text-warning'
}

export const isComplexJson = (obj, depth = 0) => {
  if (depth >= 4) {
    return true // Maximum depth reached
  }

  if (typeof obj !== 'object' || obj === null) {
    return false // Reached a primitive value
  }

  return Object.values(obj).some((value) => isComplexJson(value, depth + 1))
}

export const NumberToPrecentagesCalculation = (price, discountPrice) => {
  return Math.ceil((Number(discountPrice) / Number(price)) * 100)
}

export const PrecentagesToNumberCalculation = (price, precentages) => {
  return Math.ceil(Number(price) - PrecentagesToNumberDifferenceCalculation(price, precentages))
}

export const PrecentagesToNumberDifferenceCalculation = (price, discount) => {
  return Math.ceil(Number(price) * (Number(discount) / 100))
}

export const CalculatePrecentagesFromPriceDIfference = (monthlyPrc, discountPrc) => {
  const difference = Math.abs(Number(monthlyPrc) - Number(discountPrc))
  const result = 100 - ((difference / Number(monthlyPrc)) * 100)

  return result.toFixed(4)
}

export const hexEncoder = (str) => {
  const buffStr = Buffer.from(str).toString('hex')

  return buffStr.toString()
}

export const hexDecoder = (buffStr) => {
  const buffHex = Buffer.from(buffStr.toString(), 'hex').toString()

  return buffHex
}

export const setIncrementDate = (date, dueDay) => {
  const period = !date ? new Date() : new Date(date)
  const periodDate = period.getDate()
  const dueFilter = !dueDay
    ? 0
    : (dueDay < -30)
        ? ((periodDate === 31) ? -30 : -29)
        : dueDay
  // if periodDate == 31 and dueDay < 0 set dueDay + 1
  const dueFinal = (periodDate === 31 && (dueFilter < 0 && dueDay > -30))
    ? (dueFilter - 1)
    : dueFilter
  const due = new Date(period.setDate((periodDate + dueFinal)))

  return DateTimestr(due)
}

export function calculatePriceDiscount (price, disc) {
  return Number(price - (price * (disc / 100)))
}

export function ModalColorSelector (data) {
  if (!data) {
    return {
      isDue: true,
      paidAltStatus: '',
      dueColor: '',
      duePositiveColor: '',
      duePositiveColorList: '',
      dueColorList: ''
    }
  }
  const { dueSubsUnpaid, paid } = data

  const isDue = (new Date(dueSubsUnpaid) > new Date())
  const paidAltStatus = isDue ? 'Menunggu-Pembayaran' : 'Jatuh-Tempo'
  const dueColor = !isDue ? 'bg-warning' : 'bg-danger'
  const duePositiveColor = isDue ? 'bg-success' : 'bg-danger'

  const duePositiveColorList = !paid ? (!isDue ? 'bg-danger' : 'bg-warning') : 'bg-success'
  const dueColorList = !isDue ? 'bg-danger' : 'bg-warning'

  return {
    isDue,
    paidAltStatus,
    dueColor,
    duePositiveColor,
    duePositiveColorList,
    dueColorList
  }
}

function countTaxByPercentage (number, percentage) {
  // console.log(number, percentage)
  return Math.ceil(((Number(percentage) / 100) * Number(number)))
}

function taxCounterWithCondition (price, ppnTaxPrecentage, usePpn) {
  // console.log('tax counter input: ', price, ppnTaxPrecentage, usePpn)
  return !usePpn ? 0 : countTaxByPercentage(price, ppnTaxPrecentage)
}

export function fiberExcessCalculator (fiberPullingRange, maxFreeFiberFee) {
  const excessRange = (Number(fiberPullingRange) < Number(maxFreeFiberFee)) ? 0 : Number((Number(fiberPullingRange) - Number(maxFreeFiberFee)).toFixed(2))
  return excessRange
}

export function fiberPullingCalculator (fiberPullingRange, maxFreeFiberFee, excessFiberFeeRate, useTax, taxPercentages = 11) {
  const excessRange = fiberExcessCalculator(fiberPullingRange, maxFreeFiberFee)
  const additionalFiberFee = (Number(excessFiberFeeRate) * Number(excessRange))

  const tax = taxCounterWithCondition(additionalFiberFee, taxPercentages, useTax)
  const total = Number(additionalFiberFee) + Number(tax)
  return {
    excessRange,
    additionalFiberFee,
    tax,
    total
  }
}

export function getMimeType (ext) {
  switch (ext) {
    case 'pdf':
      return 'application/pdf'
    case 'png' || 'jpg' || 'jpeg' || 'gif' || 'webp':
      return `image/${ext === 'jpg' ? 'jpeg' : ext}`
    case 'xlsx':
      return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    case 'xls':
      return 'application/vnd.ms-excel'
    case 'doc' || 'dot':
      return 'application/msword'
    case 'docx' || 'dotx':
      return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    case 'docm' || 'dotm':
      return 'application/vnd.ms-word.document.macroEnabled.12'
    default:
      return 'application/octet-stream'
  }
}

export function getExtention (filename) {
  return !filename ? 'buffer' : filename.split('.').pop().toLowerCase()
}

export function urlQueryParamsHandler (value) {
  if (value === 'undefined' || value === 'null') {
    return null
  }

  return value
}

export function arrayCounter (arr) {
  return !arr?.length ? '-' : `[${arr.length}]`
}

export const vendorWhatsAppGatewayList = [
  { label: 'Saung-WA', value: 'saungwa' }
]

export const oltTypeList = [
  {
    value: 'global',
    label: 'Global'
  },
  {
    value: 'vsol-gpon',
    label: 'Vsol Gpon'
  },
  {
    value: 'vsol-epon',
    label: 'Vsol Epon'
  },
  {
    value: 'ZteV1',
    label: 'Zte C300/320 V1'
  },
  {
    value: 'Zte',
    label: 'Zte C300/320 V2'
  },
  {
    value: 'c-data',
    label: 'C-Data'
  },
  {
    value: 'hioso',
    label: 'Hioso'
  },
  {
    value: 'hsgq-epon',
    label: 'Hsgq Epon'
  },
  {
    value: 'hsgq-gpon',
    label: 'Hsgq Gpon'
  }
]

export const odpTypeList = [
  {
    value: 'odp',
    label: 'ODP'
  },
  {
    value: 'odc',
    label: 'ODC'
  }
]

export const RANGES_DATES_PICKER = [
  { label: '24h', hours: 24 },
  { label: '3d', hours: 72 },
  { label: '10d', hours: 240 },
  { label: '20d', hours: 480 },
  { label: '30d', hours: 720 }
]

export function fmtBytes (b, dec = 1) {
  const n = Number(b)

  if (!n || isNaN(n)) return '0 KB'

  const s = ['KB', 'MB', 'GB', 'TB']
  const labelLen = s.length
  const i = Math.floor(Math.log(n) / Math.log(1024))

  const lenPicker = (i > labelLen) ? labelLen : i
  return (n / Math.pow(1024, lenPicker)).toFixed(dec) + ' ' + s[lenPicker]
}

export function fmtPct (v, t) {
  if (!t) return '0%'
  return Math.min(100, Math.round((Number(v) / Number(t)) * 100)) + '%'
}

export function fmtTime (iso, hours) {
  const d = new Date(iso)
  if (hours <= 24) return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
  if (hours <= 240) return d.toLocaleDateString([], { month: 'short', day: 'numeric', hour: '2-digit' })
  return d.toLocaleDateString([], { month: 'short', day: 'numeric' })
}

export function fmtFull (iso) {
  if (!iso) return '—'
  return new Date(iso).toLocaleString([], { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })
}

export function norm (r) {
  return {
    ...r,
    rxByte: Number(r.rxbyte ?? r.rxByte ?? 0),
    txByte: Number(r.txbyte ?? r.txByte ?? 0),
    monthlyTotal: Number(r.monthlyTotal ?? 0),
    interfaceName: r.interfacename ?? r.interfaceName ?? '—',
    interfaceType: r.interfacetype ?? r.interfaceType ?? '—'
  }
}

export function avatarInitials (u = '') {
  const p = u.split(/[@._-]/).filter(Boolean)
  return p.length >= 2 ? (p[0][0] + p[1][0])?.toUpperCase() : u.slice(0, 2)?.toUpperCase()
}

export const Ic = {
  download: <svg viewBox="0 0 16 16" fill="none"><path d="M8 2v8M5 7l3 3 3-3M3 12h10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>,
  quota: <svg viewBox="0 0 16 16" fill="none"><rect x="2" y="3" width="12" height="11" rx="1.5" stroke="currentColor" strokeWidth="1.5" /><path d="M5 2v2M11 2v2M2 7h12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /></svg>
}

export const sortLogsByDate = (data, key, { order = 'asc', mode = 'full' } = {}) => {
  return [...data].sort((a, b) => {
    const d1 = new Date(a[key])
    const d2 = new Date(b[key])

    let valA, valB

    if (mode === '24h') {
      valA = (d1.getUTCHours() * 3600000) + (d1.getUTCMinutes() * 60000) + (d1.getUTCSeconds() * 1000)
      valB = (d2.getUTCHours() * 3600000) + (d2.getUTCMinutes() * 60000) + (d2.getUTCSeconds() * 1000)
    } else {
      valA = d1.getTime()
      valB = d2.getTime()
    }

    return order.toLowerCase() === 'desc' ? valB - valA : valA - valB
  })
}

export const paymentVendorTypeList = [
  {
    value: 'doku',
    label: 'Doku'
  }
  // {
  //     value: "midtrans",
  //     label: "Midtrans"
  // },
]

export function extractErrorMessage (err) {
  return err.response?.data?.message || err.message || 'Request failed'
}


export const DEFAULT_FILTERS = {
  severity: '',
  attackType: '',
  sourceIp: '',
  from: '',
  to: '',
  pageSize: 25
}

export const WINDOW_OPTIONS = [
  { label: '24h', hours: 24 },
  { label: '3d', hours: 72 },
  { label: '7d', hours: 168 },
  { label: '30d', hours: 720 }
]

export const emptyOverview = {
  hours: 24,
  generatedAt: null,
  counters: { total: 0, critical: 0, high: 0, uniqueSources: 0 },
  latest: null,
  attackTypes: [],
  topSources: [],
  features: []
}

export const humanize = (value) => String(value || 'Unclassified')
  .toLowerCase()
  .split('_')
  .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
  .join(' ')

export const formatTimestamp = (value) => {
  if (!value) return 'No attack recorded'
  const parsed = new Date(value)
  if (Number.isNaN(parsed.getTime())) return 'Unknown time'
  return parsed.toLocaleString('en-GB', {
    timeZone: 'Asia/Jakarta',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  })
}

export function SeverityBadge ({ severity }) {
  return <span className={`security-severity severity-${String(severity || 'low').toLowerCase()}`}>{severity || 'LOW'}</span>
}


export const SEVERITY_OPTIONS = [
  { value: 'CRITICAL', label: 'Critical' },
  { value: 'HIGH', label: 'High' },
  { value: 'MEDIUM', label: 'Medium' },
  { value: 'LOW', label: 'Low' },
];

export const toDateInput = (date) => {
  const copy = new Date(date)
  copy.setMinutes(copy.getMinutes() - copy.getTimezoneOffset())
  return copy.toISOString().slice(0, 10)
}

export const dateRangeForDays = (days) => {
  const to = new Date()
  const from = new Date()
  from.setDate(from.getDate() - (days - 1))
  return { from: toDateInput(from), to: toDateInput(to) }
}

export const formatCurrency = (value, compact = false) => new Intl.NumberFormat('id-ID', {
  style: 'currency',
  currency: 'IDR',
  maximumFractionDigits: 0,
  notation: compact ? 'compact' : 'standard'
}).format(Number(value || 0))

export const formatNumber = (value) => new Intl.NumberFormat('id-ID').format(Number(value || 0))

export const formatDateTime = (value) => {
  if (!value) return '—'
  return new Intl.DateTimeFormat('id-ID', {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit'
  }).format(new Date(value))
}

export const statusTone = (status) => {
  const normalized = String(status || '').toUpperCase()
  const numeric = Number(normalized)
  if (normalized === 'SUCCESS' || (numeric >= 200 && numeric < 300)) return 'success'
  if (['PENDING', 'PROCESSING', 'QUEUED'].includes(normalized)) return 'pending'
  return 'failed'
}

export function typeToNumber (type) {
  if (type === 'SUPERADMIN') return 2
  if (type === 'ADMIN') return 1
  return 0
}

export function formFromConfigQris (config) {
  return {
    name: config?.name || '',
    payment_vendors_id: config?.payment_vendors_id ? String(config.payment_vendors_id) : '',
    client_id: config?.client_id || '',
    mpan: config?.mpan || '',
    nmid: config?.nmid || '',
    terminal_id: config?.terminal_id || '',
    sub_merchant_id: config?.sub_merchant_id || '',
    partner_merchant_type: config?.partner_merchant_type || '',
    terminal_location_name: config?.terminal_location_name || '',
    postal_code: config?.postal_code || '',
    description: config?.description || '',
    enabled: !!config?.enabled
  }
}

export const statusClass = (status) => {
  const value = String(status || '').toUpperCase()
  if (value === 'SUCCESS' || value === '00' || value.startsWith('2')) return 'bg-success'
  if (value === 'FAIL' || value.startsWith('4') || value.startsWith('5')) return 'bg-danger'
  return 'bg-secondary'
}

export const displayDate = (value) => {
  if (!value) return '—'
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? value : date.toLocaleString('id-ID')
}

export const errorMessageHandler = (error, fallback) => error?.response?.data?.message || error?.message || fallback

export const formFromBankRoute = (route) => ({
  name: route?.name || '',
  patner_service_id: route?.patner_service_id || '',
  prefix_cust_no: route?.prefix_cust_no || '',
  payment_vendors_id: route?.payment_vendors_id ? String(route.payment_vendors_id) : '',
  bank_channel: route?.bank_channel || 'BNI',
  enabled: !!route?.enabled
})

export const getPageTitle = (pathname) => {
  const exact = pageTitles[pathname.replace(/\/$/, '')]
  if (exact) return exact
  const parent = Object.keys(pageTitles)
    .sort((a, b) => b.length - a.length)
    .find((path) => pathname.startsWith(`${path}/`))
  return pageTitles[parent] || 'ArtaPay'
}

export function formFromQrisExtConfig (config) {
  return {
    name: config?.name || '',
    payment_vendors_id: config?.payment_vendors_id ? String(config.payment_vendors_id) : '',
    prefix: config?.prefix || '',
    callback_url: config?.callback_url || '',
    description: config?.description || '',
    enabled: !!config?.enabled
  }
}
